import {
  ComponentType,
  forwardRef,
  ForwardRefExoticComponent,
  PropsWithoutRef,
  RefAttributes,
} from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { useTheme } from './index';

/**
 * Higher-order component that wraps a component with StyledThemeProvider
 * This eliminates the need to wrap each component individually
 */
export const withTheme = <P extends object, T = any>(
  Component: ComponentType<P>,
): ForwardRefExoticComponent<PropsWithoutRef<P> & RefAttributes<T>> => {
  const WithThemeComponent = forwardRef<T, P>((props, ref) => {
    const { theme } = useTheme();

    return (
      <StyledThemeProvider theme={theme}>
        <Component {...(props as P)} ref={ref} />
      </StyledThemeProvider>
    );
  });

  // Set display name for debugging
  const displayName = Component.displayName || Component.name || 'Component';
  WithThemeComponent.displayName = `withTheme(${displayName})`;

  return WithThemeComponent;
};
